var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKenya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24-.003H0v4.245h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M24 11.758H0v4.245h24v-4.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M24 5.308H0v5.377h24V5.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M15.15 2.555L13.958 2 12 6.425 10.05 2l-1.2.555L11.273 8 8.85 13.445l1.2.555L12 9.575 13.958 14l1.192-.555L12.728 8l2.422-5.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12.817 3.072A9.584 9.584 0 0012 2.277a8.912 8.912 0 00-.81.795v9.855c.253.283.523.548.81.796a9.6 9.6 0 00.817-.796V3.072z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M9.802 5v6.075c.415.743.919 1.433 1.5 2.055V2.908A10.504 10.504 0 009.803 5zm4.403 0a10.785 10.785 0 00-1.545-2.055v10.147c.595-.62 1.114-1.31 1.545-2.055V5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.197 5v6.075c.56-.93.865-1.99.886-3.075a6.196 6.196 0 00-.886-3zM9.803 5v6.075A6.195 6.195 0 018.917 8a6.195 6.195 0 01.885-3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/Kenya.06142e6c6ff46d7ac3d4ae5a289fcc76.svg";
export { ForwardRef as ReactComponent };